(function ($) {
	$(document).ready(function() {

		var  slideBox = $('.login-form-slide-box');

		$('.login-switch').click(function () {
            $(".failed-login-wrapper").removeClass("failed-login");
			slideBox.addClass('slide-register');
			$(".popup-action-title").removeClass("active-tab");
			$(this).addClass("active-tab");
		});
		$('.register-switch').click(function () {
            $(".failed-login-wrapper").removeClass("failed-login");
			slideBox.removeClass('slide-register');
            $(".popup-action-title").removeClass("active-tab");
            $(this).addClass("active-tab");
		});

		$('#loginPopup').on('show.bs.modal', function (e, a, b) {

			if (e.relatedTarget != undefined) {
				targetType = jQuery(e.relatedTarget).data('target-type');
				if (targetType != undefined && targetType != '' && targetType == 'register') {
					$('body').find('.login-form-slide-box').addClass('slide-login');
				}
				else {
					$('body').find('.login-form-slide-box').removeClass('slide-register');
				}
			}
		});
	});
})(jQuery);